import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'relay-runtime';
import { environment } from '../../Environment';

const query = graphql`
  query EntityStateQuery($state: Enums__Entity__State) {
    entityState(state: $state) {
      id
      dbId
      state
      dueDate
      entity {
        id
        dbId
        sku
        book {
          title
          genre
          authors {
            id
            dbId
            name
          }
        }
      }
    }
  }
`;

const fetch = params => fetchQuery(environment, query, params).toPromise();

export default { fetch };
